import LoyaltyClaimPointsSurvey from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-survey';

export default function ClaimPointsSurveyPage() {
  return <LoyaltyClaimPointsSurvey />;
}
